import React, { useEffect } from 'react';
import { ISocialIframeProps } from './social-embed';
import { isClient } from '../../utils/device-utils';
import { addTwitterScript } from '../../utils/socials';

const TwitterBlock: React.FC<ISocialIframeProps> = ({ src, cookieAllowed }) => {
  useEffect(() => {
    if (isClient() && cookieAllowed) {
      addTwitterScript();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cookieAllowed]);

  return (
    <blockquote className="twitter-tweet">
      <a href={src} />
    </blockquote>
  );
};

export default TwitterBlock;
